import { pletApiRequest } from './client';

// `workspaceId` (optional, may be null/'personal') pins the request to the
// workspace that was active when the operation was initiated — see client.js.
export const SprintAPI = {
  list: async (type = 'all', { workspaceId } = {}) => {
    const params = new URLSearchParams({ type });
    const result = await pletApiRequest(`/sprints?${params}`, { workspaceId });
    return result.sprints;
  },

  get: async (sprintId, { workspaceId } = {}) => {
    const result = await pletApiRequest(`/sprints/${sprintId}`, { workspaceId });
    return result.sprint;
  },

  create: async (sprint, { workspaceId } = {}) => {
    const result = await pletApiRequest('/sprints', {
      method: 'POST',
      body: JSON.stringify(sprint),
      workspaceId,
    });
    return result.sprint;
  },

  update: async (sprintId, sprint, { workspaceId, signal } = {}) => {
    const result = await pletApiRequest(`/sprints/${sprintId}`, {
      method: 'PUT',
      body: JSON.stringify(sprint),
      workspaceId,
      signal,
    });
    return result.sprint;
  },

  save: async (sprint, { workspaceId } = {}) => {
    if (sprint.id && !sprint.id.startsWith('sprint-')) {
      return SprintAPI.update(sprint.id, sprint, { workspaceId });
    }
    return SprintAPI.create(sprint, { workspaceId });
  },

  delete: async (sprintId, { workspaceId } = {}) => {
    const result = await pletApiRequest(`/sprints/${sprintId}`, {
      method: 'DELETE',
      workspaceId,
    });
    return result;
  },
};
